<script setup lang="ts">
defineProps<{ event: EventCard }>()
</script>

<template>
  <CardsEventInfoCell v-if="event.videoLink" icon="far:eye">
    <!-- TODO: This creates hydration errors, since it's a link in a link (the whole card is also a link). Should be fixed. -->
    <ClientOnly>
      <a
        :href="event.videoLink"
        target="_blank"
        rel="noopener noreferrer"
        class="leading-4 text-green-50 no-underline hover:underline"
        @click.stop
      >
        Se opptak
      </a>
    </ClientOnly>
  </CardsEventInfoCell>
</template>
